module.exports = __webpack_public_path__ + "img/40_17.935d5da4.png";